import { html, rune, View } from 'rune-ts';
import klass from './BottomSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { ButtonCtaLanding } from '../../../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';

export class BottomSection extends View {
  applyButton: ButtonCtaLanding;
  constructor() {
    super({});
    this.applyButton = new ButtonCtaLanding({
      type: 'white',
      label: ET('mps2::landing::plus::plus_apply'),
      klass: `${klass.submit} submit`,
    });
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      bottom_title: html.preventEscape(ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}bottom_title`)),
    };
    return html`
      <section class="${klass.bottom}">
        <img
          src="//s3.marpple.co/files/u_14345/2024/6/original/plus/bottom/bottom.png"
          class="${klass.bottom_bg}"
          alt="마플샵 플러스 신청하기"
        />
        <div class="${klass.content}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.bottom_title}
          </div>
          ${this.applyButton}
        </div>
      </section>
    `;
  }
}
